import common from './common' // 公共|组件|首页|个人中心

// console.log(JSON.stringify(common))

export default {
    ...common
}
